const HeaderScroll = () => {
	const header = document.getElementById('the-header');
	let lastScrollTop = 0;

	const render = () => {

		if(document.body.classList.contains('has-vbk-animation-step-1')) {
			return;
		}

		const currentScroll = window.scrollY || document.documentElement.scrollTop;

		if(currentScroll > 200) {
			if(currentScroll > lastScrollTop) {
				// Scrolling down
				//header.style.transform = 'translateY(-100%)'; // Hide header
				header.classList.add('js-hidden');
			} else {
				// Scrolling up
				//header.style.transform = 'translateY(0)'; // Show header
				header.classList.remove('js-hidden');
			}
		} else {
			//header.style.transform = 'translateY(0)'; // Show header
			header.classList.remove('js-hidden');
		}

		lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
	};

	window.addEventListener('scroll', render);
	render();
	header.classList.add('js-initialized');
};

export default HeaderScroll;